import mitt from 'mitt';
import { reactive, watch } from 'vue';

import { ROUTE_NAMES } from '@/router/route-names';

// Управление сменой городов
export default {
  install: (app, options) => {
    const authData = reactive({
      isAuthShown: false,
      authData: null,
    });

    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$auth = {
      data: authData,

      emmiter: mitt(),

      get LOGGED_IN() {
        return options.store.getters['user/loggedIn'];
      },

      onHashchange(hash) {
        switch (hash) {
          case '#register':
            if (this.LOGGED_IN) {
              options.store.dispatch('notifications/create', {
                title: 'Вы уже авторизованы!',
                type: 'success',
              });
              options.router.replace({ hash: '' });
              break;
            }
            this.login()
              .then(() => { })
              .catch(() => { })
              .finally(() => {
                options.router.replace({ hash: '' });
              });
            break;
          case '#registerandblock':
            if (this.LOGGED_IN) {
              options.router.replace({ name: ROUTE_NAMES.AccountBlock, hash: '' });
            }
            this.login()
              .then(() => {
                options.router.replace({ name: ROUTE_NAMES.AccountBlock, hash: '' });
              })
              .catch(() => {});
            break;
          default: break;
        }
      },

      login(data) {
        if (this.LOGGED_IN) return Promise.resolve();

        return new Promise((resolve, reject) => {
          authData.authData = data;
          authData.isAuthShown = true;

          this.emmiter.on('login', () => {
            authData.authData = null;
            authData.isAuthShown = false;
            this.emmiter.off('login');
            resolve({ loginProcessSucceed: true });
          });

          this.emmiter.on('login:close', () => {
            authData.authData = null;
            authData.isAuthShown = false;
            this.emmiter.off('login:close');
            reject();
          });
        });
      },

      sendRequestCode({ resolve, reject, request }) {
        const response = {
          timer: 0,
        };

        return options.store.$apiBFF.requestAuthCode(request)
          .then((r) => {
            response.timer = Math.round(r.timer / 1000);

            return resolve(response);
          })
          .catch(({ error } = {}) => {
            if (error.timer) {
              return reject({
                error: {
                  ...error,
                  code: error.code,
                  timer: Math.round(error.timer / 1000),
                },
              });
            }

            return reject({ error });
          });
      },

      requestCode({ request = {} } = {}) {
        return new Promise((resolve, reject) => {
          this.sendRequestCode({ resolve, reject, request });
        });
      },
    };

    watch(() => options.router.currentRoute.value.hash, (hash) => {
      app.config.globalProperties.$auth.onHashchange(hash);
    });
  },
};
